<template>
  <div class="bookmarks">
    <div class="input-name">{{ $i18n.t('Bookmarks') }}</div>
    <el-input class="bookmark-input" type="text" prefix-icon="el-icon-collection-tag" v-model="urlTitle"></el-input>
    <div class="input-name">{{ $i18n.t('Url') }}</div>
    <el-input
      class="bookmark-input"
      type="url"
      v-model="urlValue"
      prefix-icon="el-icon-link"
      :placeholder="$i18n.t('Current URL')"
    ></el-input>
    <el-button type="default" icon="el-icon-plus" @click.prevent="clickSave">{{ $i18n.t('Create') }}</el-button>
    <div>
      <div class="saved-bookmarks">
        <div class="bookmark-items" v-for="(item, index) in urls" :key="index">
          <a class="bookmark-item" :href="item.url">{{ item.title }}</a>
          <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="remove(item, index)"></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import notify from '@/utils/mixin-notify'

/**
 * @class Bookmark
 * @description bookmakring urls in menu
 */
export default {
  name: 'Bookmark',
  mixins: [notify],
  data() {
    return {
      urls: [],
      urlTitle: '',
      urlValue: '',
      user: parseInt(get(window, 'CORE.params.ID_S_USER')),
      system: parseInt(get(window, 'CORE.params.ID_SUBSYSTEM')),
    }
  },
  props: {
    activeComponent: {
      type: String,
      default: '',
    },
  },
  methods: {
    async load() {
      await this.$client
        .execute({
          operationId: 'Bookmarks_find',
          parameters: {
            filter: JSON.stringify({
              where: {
                system: this.system,
                updateUser: this.user,
                storno: 0,
              },
            }),
          },
        })
        .then((result) => {
          this.urls = result.body
        })
    },
    clickSave() {
      const data = {
        title: this.urlTitle,
        url: this.urlValue,
        system: this.system,
        storno: 0,
      }
      const parameters = {
        where: JSON.stringify({
          url: this.urlValue,
        }),
        data,
      }
      if (this.urls.filter((item) => item.url === data.url).length === 0) {
        this.saveMongo(parameters)
        this.urls.push(data)
      }
    },
    remove(item, index) {
      const data = {
        storno: 1,
      }
      const parameters = {
        where: JSON.stringify({
          system: this.system,
          updateUser: this.user,
          url: item.url,
        }),
        data,
      }
      this.saveMongo(parameters)
      this.$delete(this.urls, index)
    },
    saveMongo(parameters) {
      this.$client
        .execute({
          operationId: 'Bookmarks_upsertWithWhere',
          method: 'post',
          parameters,
        })
        .then((response) => {
          if (get(response, 'status') === 200) {
            if (get(response, 'body.storno', 0) === 1)
              this.showNotification({
                text: '${title}_bookmark_deleted',
                params: { title: response.body.title },
                type: 'success',
              })
            else
              this.showNotification({
                text: '${title}_bookmark_saved',
                params: { title: response.body.title },
                type: 'success',
              })
          } else {
            this.showNotification({
              text: '${title}_bookmark_save_error',
              params: { title: response.body.title },
              type: 'error',
            })
          }
        })
    },
  },
  mounted() {
    this.urlTitle = document.title
    this.urlValue = document.location.pathname + document.location.search
    this.load()
  },
  watch: {
    activeComponent(newValue, oldValue) {
      if (newValue === this.$options.name) {
        this.load()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/variables';
.bookmarks {
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  gap: 15px;
}
.input-name {
  padding-left: 10px;
  font-size: 16px;
  color: $icon-large;
}
.saved-bookmarks {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bookmark-items {
  width: 95%;
  background: $light1;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 5px 5px 15px;
}
.bookmark-item {
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  color: $color-text-primary;
  width: 100%;
  line-height: 1;
}
</style>
